const ShareIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 64 64"
    >
      <g>
        <g>
          <g>
            <circle cx="32" cy="26" r="12" />
          </g>
        </g>
        <g>
          <g>
            <path d="M37.5,41h-11C19.1,41,13,47,13,54.4V61h38v-6.6C51,47,44.9,41,37.5,41z" />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M16.1,24C16.1,24,16.1,24,16.1,24c0.3-2.1,0.9-4.1,2-5.9c0,0,0,0,0-0.1c0.5-0.9,1.1-1.7,1.7-2.4c0,0,0.1-0.1,0.1-0.1
				c0.6-0.7,1.3-1.4,2-2c0.1-0.1,0.1-0.1,0.2-0.2c0.7-0.6,1.5-1.1,2.4-1.5c0.1,0,0.2-0.1,0.3-0.1c0.3-0.1,0.5-0.3,0.8-0.4
				c0,0,0,0,0,0C24.4,7,20.4,3.8,15.7,4C10.1,4.2,5.8,8.8,6,14.3C6.2,19.8,10.7,24.1,16.1,24z"
            />
          </g>
        </g>
        <g>
          <g>
            <path d="M21.2,37.8c-3-2.7-4.9-6.5-5.2-10.8h-4.7C5.1,27,0,32.4,0,38.9V49h9.9C11.6,43.7,15.8,39.5,21.2,37.8z" />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M39.2,11.7c0.1,0,0.2,0.1,0.3,0.1c0.8,0.4,1.6,1,2.4,1.5c0.1,0.1,0.1,0.1,0.2,0.2c0.7,0.6,1.4,1.3,2,2
				c0,0,0.1,0.1,0.1,0.1c0.6,0.7,1.2,1.5,1.7,2.4c0,0,0,0,0,0.1c1,1.8,1.7,3.8,2,5.9c0,0,0,0,0,0c5.4,0.1,10-4.2,10.1-9.7
				C58.2,8.8,53.9,4.2,48.3,4c-4.7-0.2-8.8,3-10,7.3c0,0,0,0,0,0C38.7,11.5,38.9,11.6,39.2,11.7z"
            />
          </g>
        </g>
        <g>
          <g>
            <path d="M52.6,27H48c-0.3,4.3-2.2,8.1-5.2,10.8c5.4,1.7,9.6,5.9,11.3,11.2H64V38.9C64,32.4,58.9,27,52.6,27z" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ShareIcon;
